import { JsonSchema, Layout } from '@jsonforms/core';
import { JsonFormsDispatch, useJsonForms } from '@jsonforms/react';
import isEmpty from 'lodash/isEmpty';
import { ReactElement } from 'react';
export interface RenderChildrenProps {
  layout: Layout;
  schema: JsonSchema;
  className: string;
  path: string;
}

export const renderChildren = (
  layout: Layout,
  schema: JsonSchema,
  className: string,
  path: string
): ReactElement[] => {
  if (isEmpty(layout.elements)) {
    return [];
  }

  return layout.elements.map((child, index) => {
    const { renderers, cells } = useJsonForms();
    return (
      <div className={className} key={`${path}-${index}`}>
        <JsonFormsDispatch
          renderers={renderers}
          cells={cells}
          uischema={child}
          schema={schema}
          path={path}
        />
      </div>
    );
  });
};
